import { UFO_RULES as R, type UfoBonusEvent } from '../../../../shared/ufoRules';

/** Sorular arası seyirde sağdan gelen yıldız/göktaşı. x ve y uçuş alanına göre normalize (0–1). */
export type CruiseObject = { kind: UfoBonusEvent; y: number; spawnMs: number; x: number; takenAt: number | null };

export const cruiseFieldRules = {
  /** Nesnelerin ekranı geçiş hızı (uçuş alanı genişliği / saniye). */
  speed: 0.55,
  startX: 1.06,
  /** UFO'nun yakalama kutusu: temas çizgisi çevresinde yatay ve dikey yarı genişlikler. */
  catchHalfWidth: 0.045,
  catchHalfHeight: 0.09,
  /** Güvenilir çarpışma için seyirde en büyük simülasyon adımı (ms). */
  maxStepMs: 16,
  rows: [0.16, 0.33, 0.5, 0.67, 0.84],
} as const;

const F = cruiseFieldRules;
/** Bir seyirdeki doğuş zamanları (ms): üç yıldız ve iki göktaşı, hepsi seyir bitmeden UFO hizasını geçer. */
const SPAWNS: readonly { kind: UfoBonusEvent; at: number; row: number }[] = [
  { kind: 'star', at: 150, row: 0 },
  { kind: 'asteroid', at: 480, row: 2 },
  { kind: 'star', at: 760, row: 1 },
  { kind: 'asteroid', at: 1080, row: 4 },
  { kind: 'star', at: 1380, row: 3 },
];

/** Seyir numarasına göre deterministik dizilim; her öğrencide aynı soru arasında aynı düzen. */
export function createCruiseField(cruiseIndex: number): CruiseObject[] {
  const shift = (cruiseIndex * 2) % F.rows.length;
  return SPAWNS.map((spawn) => ({ kind: spawn.kind, y: F.rows[(spawn.row + shift) % F.rows.length], spawnMs: spawn.at, x: F.startX, takenAt: null }));
}

/** Nesneleri seyir içindeki zamana taşır ve UFO'nun yakaladıklarını olay olarak döndürür. */
export function advanceCruiseField(objects: CruiseObject[], cruiseElapsedMs: number, ufoY: number, clock: number): UfoBonusEvent[] {
  const events: UfoBonusEvent[] = [];
  for (const object of objects) {
    object.x = cruiseElapsedMs < object.spawnMs ? F.startX : F.startX - F.speed * (cruiseElapsedMs - object.spawnMs) / 1000;
    if (object.takenAt !== null) continue;
    if (Math.abs(object.x - R.contactX) <= F.catchHalfWidth && Math.abs(object.y - ufoY) <= F.catchHalfHeight) {
      object.takenAt = clock; events.push(object.kind);
    }
  }
  return events;
}
